import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState } from './state';

export const selectUser = createFeatureSelector<UserState>('user');

export const selectUserProfile = createSelector(
  selectUser,
  (user: UserState) => user && user.profile
)

export const selectIsAuthenticated = createSelector(
  selectUser,
  (user: UserState) => !!user && user.isAuthenticated
)

export const selectIsAtLeastJanitor = createSelector(
  selectUser,
  (user: UserState) => !!user && user.isAtLeastJanitor
)
